/**
 * Admin gate — username-based, no DB role column.
 *
 * Until the backend gets a proper user_role column, admin capability is
 * decided from a hardcoded allowlist. Keep this list in sync with the
 * server-side check in HandleReportReopen (uTCPDM1.pas) — the frontend
 * only hides/shows the affected controls, the server is the actual gate.
 *
 * Match is case-insensitive so "Sriram", "sriram", "SRIRAM" all pass.
 */
export const ADMIN_USERNAMES = ['sriram', 'admin', 'claudeai'];

export function isAdminUsername(username: string | null | undefined): boolean {
  if (!username) return false;
  const u = username.trim().toLowerCase();
  return ADMIN_USERNAMES.includes(u);
}
